import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/gcd-lcm-calculator',
  component: () => import('../../routes/GcdLcmCalculator.svelte'),
  card: {
    id: 'gcd-lcm-calculator',
    title: 'GCD & LCM Calculator',
    description: 'Find the greatest common divisor and least common multiple of any two integers with step-by-step Euclidean algorithm breakdown.',
    icon: 'calculate',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/gcd-lcm-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'GCD & LCM Calculator – Greatest Common Divisor & Least Common Multiple',
    description: 'Free GCD and LCM calculator. Find the greatest common divisor and least common multiple of any two numbers with step-by-step Euclidean algorithm breakdown and prime factorization.',
  },
};

export default meta;
